import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { assertLegacyFirebaseDataSource } from 'shared/api/dataSource'

// Firestore and Storage remain available only for an explicitly selected legacy
// data source. Keeping the imports dynamic prevents either SDK from joining the
// normal backend-powered application bundle.
export const loadLegacyFirestore = async () => {
    assertLegacyFirebaseDataSource()
    const firestore = await import('firebase/firestore')
    return {
        ...firestore,
        db: firestore.getFirestore(app),
    }
}

export const loadLegacyStorage = async () => {
    assertLegacyFirebaseDataSource()
    const storage = await import('firebase/storage')
    return {
        ...storage,
        imageDb: storage.getStorage(app, 'gs://taglife-images'),
    }
}
